import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotasInput from './NotasInput';

const Notas = () => {
  return (
    <Routes>
      <Route path="/" element={<NotasInput />} />
      <Route path="*" element={<Navigate to="/notas" replace />} />
    </Routes>
  );
};

export default Notas;
